import axios from "axios";
import secureLocalStorage from "react-secure-storage";
export const get_check_leave_approvals = async () => {
    const response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/check-leave-approvals`)
    return response.data;
}